export function initServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(`/service-worker.js?t=${+new Date()}`, {
        scope: '/',
      });
    });
  }
}
